export const contactKey = {
    PUBLIC_ID: 'Kh1najMS5JidQjVkR',
    TEMPLATE_ID: 'template_vxky256',
    SERVICE_ID: 'service_5a8cex8',
}